import React, { useState, useEffect } from "react";
import "../App.less";
import axios from "axios";
import Banner from "./Banner";
import { useNavigate } from 'react-router-dom';
import ScientiaHeader from "./ScientiaHeader";
import Hero from "./Hero";
import Section from "./Section";
import ScientiaProducts from "./ScientiaProducts";
import ScientiaFooter from "./ScientiaFooter";
import { MenuPane } from './MenuPane';
import Cookies from 'universal-cookie';
import { REF_CURRENT_USER_ID } from "nexus-common/src/components/access/constants";
const cookies = new Cookies();

interface Props {
    currentUser: any;
    logoutHandler: any;
}

const Dashboard: React.FC<Props> = ({ currentUser, logoutHandler }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [url, setUrl] = useState<string | null>(null);
    const history = useNavigate();
    const handleMenuToggle = () => {
      setMenuOpen(!menuOpen); 
    };
    const[isTahomaUser, setIsTahomaUser] = useState('');
  
    useEffect(() => {
      const productSection = document.querySelector('.product-section') as HTMLElement;
      const heroText = document.querySelector('.text') as HTMLElement;
      const redirect_card_url = sessionStorage.getItem('card_click_url');
      if(currentUser && redirect_card_url) {
        setUrl(redirect_card_url);
        sessionStorage.removeItem('card_click_url');
      }
      if (productSection) {
        if (currentUser) {
          productSection.style.marginLeft = menuOpen ? '340px' : '88px';
          if(heroText){
            heroText.style.marginLeft = menuOpen ? '340px' : '0';
          }
        } else {
          productSection.style.marginLeft = '0px';
          if(heroText){
            heroText.style.marginLeft = '0';
          }
        }
      }
    }, [menuOpen]);

    useEffect (() => {
        const fetchIsTahomaUser = async () => {
            try {
                const currentUserId = currentUser?.user_id;
                if(currentUserId) {
                  const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/getIsTahomaUser/${currentUserId}`);
                  const tahomaUser = response.data;
                  setIsTahomaUser(tahomaUser);
                }
            } catch (error) {
                console.error("Error fetching current user tahoma access status", error);
            }
          }
        fetchIsTahomaUser()
    },[currentUser])

    const transformUrl = (originalUrl: string, map: { [key: string]: string }) => {
      let fullUrl = originalUrl;
      let shorthandUrl = originalUrl;

      // Helper to get the first segment (before first slash after protocol or at start)
      const getFirstSegment = (url: string) => {
        if (url.startsWith("http://") || url.startsWith("https://")) {
          const match = url.match(/^https?:\/\/[^/]+\/?/);
          return match ? match[0] : url;
        } else {
          return url.split("/")[0];
        }
      };

      const originalFirst = getFirstSegment(originalUrl);
      const shorthandKey = Object.entries(map).find(
        ([key, value]) =>
          getFirstSegment(key) === originalFirst || getFirstSegment(value) === originalFirst
      );

      if (shorthandKey) {
        const [fullKey, value] = shorthandKey;
        if (originalUrl.startsWith(value)) {
          // replace the value from the start with fullKey
          fullUrl = originalUrl.replace(value, fullKey);
          shorthandUrl = originalUrl;
        } else {
            shorthandUrl = originalUrl.replace(fullKey, value);
            fullUrl = originalUrl;
        }
      } else {
        const fullKey = Object.keys(map).find((key) => originalUrl.includes(key));
        if (fullKey) {
          const value = map[fullKey];
          shorthandUrl = originalUrl.replace(fullKey, value);
          fullUrl = originalUrl;
        }
      }
      return { fullUrl, shorthandUrl };
    };


    const urlMap: { [key: string]: string } = {
      [process.env.REACT_APP_METADATA as string]: "metadata",
      [process.env.REACT_APP_PROPOSAL_MANAGEMENT as string]: "proposal_management",
      [process.env.REACT_APP_DATA as string]: "data",
      ALL_CARDS: "all_cards",
      MODELING_WORKBENCH_CARDS: "modeling_workbench_cards",
      INSIGHT_ENGINE_CARDS: "insight_engine_cards",
      LIMS_CARDS: "lims_cards",
    };
    
    useEffect(() => {
      const url_params = () => {
        const params = new URLSearchParams(window.location.search);
        const subSrc = params.get("subSrc");
        return { subSrc };
      };
      
      const { subSrc } = url_params();
      if (currentUser && subSrc) {
        const decodedIframeUrl = decodeURIComponent(subSrc);
        const { fullUrl, shorthandUrl } = transformUrl(decodedIframeUrl, urlMap);
        // Update the browser's URL for display purposes
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("subSrc", shorthandUrl);
        window.history.pushState(null, "", newUrl.toString());
        setUrl(fullUrl);
      } else if (!currentUser && subSrc) {
        loginredirect(subSrc)
        return;
      }
      
      const handlePopState = () => {
        sessionStorage.removeItem("refreshUrl");
        const { subSrc } = url_params();
        if (currentUser && subSrc ) {
          const { fullUrl } = transformUrl(decodeURIComponent(subSrc), urlMap);
          setUrl(fullUrl);
        } else {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.delete("subSrc");
          window.history.replaceState(null, "", newUrl.toString());
          setUrl(null);
        }
      };
      
      window.addEventListener("popstate", handlePopState);
      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }, [currentUser]);
    
    const handleExternalLinkClick = (url: string, e?: any) => {
      sessionStorage.setItem("refreshUrl", url);
      if (currentUser) {
        const { fullUrl, shorthandUrl } = transformUrl(url, urlMap);
        setUrl(fullUrl);
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("subSrc", shorthandUrl);
        window.history.pushState(null, "", newUrl.toString());
      } else if (!currentUser && (url === process.env.REACT_APP_DATA || url === "ALL_CARDS")) {
        sessionStorage.setItem('card_click_url', url);
        // set subSrc of url to data or all_cards respectively
        const newUrl = new URL(window.location.href);
        const { shorthandUrl } = transformUrl(url, urlMap);
        newUrl.searchParams.set("subSrc", shorthandUrl);
        window.history.pushState(null, "", newUrl.toString());
        setUrl(url);
      } else {
        sessionStorage.setItem('card_click_url', url);
        loginredirect(url);
      }
    };

    const loginredirect = (url: string) => {
      const { fullUrl, shorthandUrl } = transformUrl(url, urlMap);
      sessionStorage.setItem('card_click_url', fullUrl);
      const loginUrl = new URL(window.location.origin + '/login');
      loginUrl.searchParams.set('subSrc', shorthandUrl);
      history(loginUrl.pathname + loginUrl.search);
    }

    const getNetworkId = async (): Promise<string | null> => {
      const user_id = cookies.get(REF_CURRENT_USER_ID);
      try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/getNetworkId/${user_id}`);
        return response.data;
      } catch (error) {
        console.error(error, "Error fetching network id");
        return null;
      }
    }

    const deleteAllJupyterHubServers = async (): Promise<string> => {
      try {
          const network_id = await getNetworkId();
          if (!network_id) {
              console.error("Network ID not found");
              return "Network ID not found";
          }
            const result = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/jupyterhub/delete_all_servers`, {network_id}
            ).then((response) => {
              if (response.data === 'All servers deleted successfully') {
                return "All servers deleted successfully";
              }
              return "Failed to delete servers";
            });

          return result;
      } catch (error) {
          console.error(error, "Error deleting all servers");
          return "Error deleting servers";
      }
    };

    const getActiveJupyterHubServerList = async (server: string): Promise<boolean> => {
      const network_id = await getNetworkId();
      const active_server = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/jupyterhub/get_active_servers/${network_id}`)
      if (active_server.data.length > 0 && server === active_server.data) {
        return true;
      } else {
        return false;
      }
    }

    return (

      <div className="scientia">
        <ScientiaHeader currentUser={currentUser} logoutHandler={logoutHandler} handleMenuToggle={handleMenuToggle} onExternalLinkClick={handleExternalLinkClick}  />
        <Banner loggedIn={!!currentUser} menuOpen={menuOpen} />
        <Hero currentUser={currentUser} />
        <MenuPane isOpen={menuOpen} onClose={handleMenuToggle} currentUser={currentUser} onExternalLinkClick={handleExternalLinkClick} isTahomaUser={isTahomaUser} deleteAllJupyterHubServers={deleteAllJupyterHubServers} getActiveJupyterHubServerList={getActiveJupyterHubServerList}/>
        <ScientiaProducts urlParam={url} currentUser={currentUser} onExternalLinkClick={handleExternalLinkClick} isTahomaUser={isTahomaUser} urlMap={urlMap} deleteAllJupyterHubServers={deleteAllJupyterHubServers} getActiveJupyterHubServerList={getActiveJupyterHubServerList}/>
        {!currentUser && <Section />}
        {!currentUser && <ScientiaFooter onExternalLinkClick={handleExternalLinkClick} />}
      </div>
    );
};

export default Dashboard
